const state = {
    user: {
        name: '',
        id: ''
    },
    baseUrl: 'http://www.topgene.cn'
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js